<svelte:options accessors/>
<script lang="ts">

    import {v4 as uuidv4} from 'uuid';
    import NauiInput from "../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../naui/atoms/NauiSelect.svelte";
    import DocumentTable from "../common/DocumentTable.svelte";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import NauiFloatingAction from "../naui/components/NauiFloatingAction.svelte";
    import NauiCheckbox from "../naui/atoms/NauiCheckbox.svelte";
    import {createEventDispatcher} from "svelte";
    import {onMount} from "svelte";
    import NauiSearch from "../naui/components/NauiSearch.svelte";

    const dispatch = createEventDispatcher();
    export let entitySearchCmpt;
    export let entityCodeSearchCmpt;

    export let data: any = {};
    export let client: any = {};
    export let clients = [];
    export let zones = [];
    export let editable: boolean = true;
    let documentTable;
    let options = [];
    let documentTableSchema = {
        label: true,
        archivo: true,
        category: false,
        completed: false
    }
    export let docs = []
    export let modal;

    onMount(() => {
        options = (clients || []).map((c) => ({
            value: c.id,
            label: c.name,
            code: c.code
        }));
        if (entitySearchCmpt && client) {
            entitySearchCmpt.$set({
                selectedItem: client
            });
            entitySearchCmpt.updateSelectedItem();
        }
        if (entityCodeSearchCmpt) {
            entityCodeSearchCmpt.$set({
                selectedItem: client
            });
            entityCodeSearchCmpt.updateSelectedItem();
        }
    });

    function getData() {
        refreshDocuments();
        return {
            ...data,
            docs: docs
        }
    }

    function changeClient() {
        const find = clients.find(c => c.id === data.infoGeneral.entidad);
        data.infoGeneral.codigoEntidad = find.code;
    }

    function findClient() {
        dispatch('search', {
            term: data.infoGeneral.codigoEntidad
        });
    }

    function refreshDocuments(): void {
        if (documentTable) {
            const aux = documentTable._data || [];
            docs.forEach((d: any) => {
                const find = aux.find(d => d.slug === d.slug);
                d.label = find.label;
                d.archivo = find.archivo;
            });
        }
    }

    function addDocument() {
        if (documentTable) {
            refreshDocuments();
            docs.push({
                slug: uuidv4(),
                label: '',
                archivo: null
            });
            documentTable.refresh();
        }
    }

    export function setUrl(params: { url: string, uuid: string }): void {
        if (documentTable) {
            refreshDocuments();
            const find = docs.find(d => d.slug === params.uuid);
            if (find) {
                find.route = params.url;
            }
            documentTable.refresh();
        }
    }

    function removeDocument(response: any) {
        if (documentTable) {
            const {slug} = response.detail;
            refreshDocuments();
            const index = docs.findIndex(d => d.slug === slug);
            docs.splice(index, 1);
            documentTable.refresh();
        }
    }

    function next() {
        if (validate()) {
            dispatch('next', getData());
        } else {
            openModal();
        }

    }

    function save(): void {
        if (validate()) {
            dispatch('save', getData());
        } else {
            openModal();
        }
    }

    function openModal() {
        modal.openModal({
            closeButton: false,
            closeOnEsc: true,
            closeOnOuterClick: true,
            message: `<p>Alguno de las datos no es valido o no ha sido diligenciado.</p>`,
            button: 'ACEPTAR'
        });
    }

    function validate(): boolean {
        const keys = [
            'entidad',
            'codigoEntidad',
            'noProceso',
            'objeto',
            'zona',
        ]
        const infoGral = data.infoGeneral || {};
        return keys.every((key: string) => !!infoGral[key]);
    }

    export function setResults(el: Array<any>) {
        entitySearchCmpt.$set({
            items: el,
            show: true
        });
        entityCodeSearchCmpt.$set({
            items: el,
            show: true
        });
    }

    function handleSelectByName(evt) {
        entityCodeSearchCmpt.$set({
            selectedItem: evt.detail
        });
        entityCodeSearchCmpt.updateSelectedItem();
        setEntidad(evt.detail);

    }

    function handleSelectByCode(evt) {
        entitySearchCmpt.$set({
            selectedItem: evt.detail
        });
        entitySearchCmpt.updateSelectedItem();
        setEntidad(evt.detail);
    }

    function setEntidad(entity) {
        data.infoGeneral.codigoEntidad = entity.code;
        data.infoGeneral.entidad = entity.id;
        data.infoGeneral.entidadName = entity.name;
    }
</script>
<fieldset>
    <legend>Información general</legend>
    <div class="max-w-1000px">
        <div class="grid-4 gap-1 mb-1">
            <div class="col-2">
                <NauiSearch bind:this={entitySearchCmpt}
                            on:search
                            on:selected={handleSelectByName}
                            isDisabled={!editable}/>
            </div>
            <div>
                <NauiSearch bind:this={entityCodeSearchCmpt}
                            label="Código entidad"
                            key="code"
                            on:search
                            on:selected={handleSelectByCode}
                            isDisabled={!editable}/>
            </div>
            <div>
                <NauiInput label="No. Proceso"
                           isDisabled={!editable}
                           bind:value={data.infoGeneral.noProceso}/>
            </div>
        </div>
        <div class="grid-4 gap-1 mb-1">
            <div class="col-2">
                <NauiInput label="Objeto"
                           isDisabled={!editable}
                           bind:value={data.infoGeneral.objeto}/>
            </div>
            <div>
                <NauiInput label="Presupuesto"
                           type="number"
                           isDisabled={!editable}
                           bind:value={data.infoGeneral.presupuesto}/>
            </div>
            <div>
                <NauiSelect label="Zona"
                            isDisabled={!editable}
                            options={zones}
                            bind:value={data.infoGeneral.zona}/>
            </div>
        </div>
    </div>
    <div class="max-w-1000px">
        <div class="grid-2 gap-1">
            <div>
                <div>
                    <NauiCheckbox bind:value={data.infoGeneral.esGrupoEmpresarial}
                                  isDisabled={!editable}
                                  label="Es un grupo empresarial"/>
                </div>
                {#if data.infoGeneral.esGrupoEmpresarial}
                    <div class="min-w-250px">
                        <NauiInput type="text"
                                   label="Nombre del grupo"
                                   isDisabled={!editable}
                                   bind:value={data.infoGeneral.grupoEmpresarial}/>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</fieldset>
<fieldset>
    <legend>Documentos relevantes</legend>
    <div style="max-width: 600px">
        <DocumentTable bind:this={documentTable}
                       data={docs}
                       checkbox={false}
                       tableSchema={documentTableSchema}
                       on:file
                       on:remove={removeDocument}
                       readOnly={!editable}
                       documentoLabel="Nombre del documento"/>
        {#if editable}
            <NauiButton size="small"
                        caption="AÑADIR DOCUMENTO"
                        icon="plus"
                        color="accent"
                        on:click={addDocument}/>
        {/if}
    </div>
</fieldset>
{#if editable}
    <div class="mt-3">
        <NauiButton size="small" caption="CONTINUAR" mode="solid" color="accent" on:click={next}/>
    </div>
{/if}
{#if editable}
    <NauiFloatingAction>
        <NauiButton size="small"
                    caption="GUARDAR"
                    mode="solid"
                    icon="save"
                    color="accent"
                    on:click={save}/>
    </NauiFloatingAction>
{/if}